import { Avatar, Tab, Tabs } from "@material-ui/core";
import clsx from "clsx";
import React, { useState } from "react";
import userPhotoDefault from "../../assets/img/defaultUser.png";
import PrincipalIcon from "../../assets/img/logo-white.png";
import AddPrincipalIcon from "../../assets/img/logo-plus.svg";
import Dialog from "../../components/common/Dialog";
import TitleTab from "../../components/common/TitleTab";
import useBreakpoint from "../../hooks/useBreakpoint";
import useConfig from "../../hooks/useConfig";
import useShowImage from "../../hooks/useShowImage";
import { useStore } from "../../hooks/useStore";
import useTabs from "../../hooks/useTabs";
import { useTranslation } from "../../hooks/useTranslation";
import { Config } from "../../store/types/userTypes";
import useStyles from "./TabBarStyles";

const a11yProps = (index: string) => {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
};

const TabBar = () => {
  const classes = useStyles();
  const { tabStore } = useStore();
  const showImage = useShowImage();
  const [openOnHoldDialog, setOpenOnHoldDialog] = useState(false);
  const { t, BundleKey } = useTranslation();
  const { onChangeTab, onChangeTabPreselect, onCloseTab } = useTabs();
  const { openDialogAreYouSure } = useConfig();
  const { isMobile } = useBreakpoint();

  const onChange = (event: any, value: string) => {
    event.stopPropagation();
    event.cancelBubble = true;
    onChangeTab(value, () => {
      setOpenOnHoldDialog(true);
    });
  };

  const onUsePreselectChange = () => {
    onChangeTabPreselect();
  };

  const onTabClose = (value: number) => {
    openDialogAreYouSure({
      action: () => {
        onCloseTab(value);
      },
    });
  };

  const getStyleAvatar = (config?: Config | null, isMultipleExit?: boolean) => {
    return config
        ? config.eventType === "in"
            ? classes.entry
            : classes.exit
        : isMultipleExit
            ? classes.exit
            : "";
  };

  return (
      <>
        <Tabs
            value={tabStore.tabSelectIndex}
            className={clsx(isMobile ? classes.rootMobile : classes.root, {
              [classes.mobile]: isMobile,
            })}
            onChange={onChange}
            variant="scrollable"
            scrollButtons={isMobile ? "on" : "auto"}
        >
          <Tab
              {...a11yProps("-1")}
              value="-1"
              className={isMobile ? classes.tabRootMobile : classes.tabRoot}
              icon={
                <Avatar
                    className={classes.avatar}
                    alt="Remy Sharp"
                    src={
                      tabStore.tabSelectIndex === "-1"
                          ? PrincipalIcon
                          : AddPrincipalIcon
                    }
                />
              }
          />
          {tabStore.tabs.map((tab) => (
              <Tab
                  key={tab.index}
                  label={
                    <TitleTab
                        title={`${tab.state?.firstname || ""} ${
                            tab.state?.lastname || ""
                        }`}
                        onClose={(event) => {
                          event.stopPropagation();
                          event.cancelBubble = true;
                          onTabClose(tab.index);
                        }}
                        entry={tab.state?.config?.eventType === "in"}
                        exit={tab.state?.config?.eventType === "out"}
                        isMultipleExit={tab.isMultipleExit}
                        warning={
                          tab.index.toString() === tabStore.tabSelectIndex
                              ? tabStore.tabSelectWithWarning
                              : false
                        }
                    />
                  }
                  {...a11yProps(tab.id)}
                  value={tab.index.toString()}
                  className={isMobile ? classes.tabMobile : classes.tab}
                  icon={
                    isMobile ? (
                        <Avatar
                            className={clsx(classes.avatar, {
                              [classes.avatarMobile]: isMobile,
                            })}
                        >
                          {tab.state?.config?.eventType === "in"
                              ? "IN"
                              : tab.state?.config?.eventType === "out"
                                  ? "OUT"
                                  : tab.isMultipleExit
                                      ? "OUT"
                                      : ""}
                        </Avatar>
                    ) : (
                        <Avatar
                            className={classes.avatar}
                            alt="Profile Photo"
                            src={showImage(tab.state?.facePhoto) || userPhotoDefault}
                        />
                    )
                  }
              />
          ))}
        </Tabs>
        <Dialog
            open={openOnHoldDialog}
            labelNo={t(BundleKey.ACTION_CANCEL)}
            labelYes={t(BundleKey.TAB_ONHOLD_ACTION)}
            onClose={() => setOpenOnHoldDialog(false)}
            onSubmit={onUsePreselectChange}
            title={t(BundleKey.TAB_ONHOLD_MESSAGE)}
        />
      </>
  );
};

export default TabBar;
